import {
  IRootWidget,
  TreeNavigatorLogic,
  getWidgetName,
  isRoot,
} from '@framework/engine';
import {
  IModuleTriggerWidget,
  isModuleTriggerWidget,
} from './IModuleTriggerWidget';

export interface ITriggerableModuleData {
  moduleId: string;
  widgetId: string;
  widgetCode: string;
}

/**
 * Ritorna la lista dei moduli attivabili in una sezione.
 * Scorre su tutto il widget tree e ritorna i dati relativi ai widget "Attiva modulo".
 */
export function getTriggerableModules(
  root: IRootWidget | null | undefined,
): ITriggerableModuleData[] {
  if (!root) return [];
  const result: ITriggerableModuleData[] = [];
  TreeNavigatorLogic.forEachNode(root, node => {
    if (isRoot(node)) return;
    if (isModuleTriggerWidget(node)) {
      const moduleTriggerWidget = node as IModuleTriggerWidget;
      // Se il modulo non è configurato, non lo considero
      if (!moduleTriggerWidget.moduleId) return;

      const data = {
        moduleId: moduleTriggerWidget.moduleId,
        widgetId: moduleTriggerWidget.id,
        widgetCode: getWidgetName(moduleTriggerWidget),
      };
      result.push(data);
    }
  });

  return result;
}
